/**
 * MapLibre source and layer ID constants for the public land overlay.
 * Defined here (not in PublicLandLayer.tsx) to avoid non-component exports
 * from a .tsx component file (RULE-044 / react-refresh lint constraint).
 */
export const PUBLIC_LAND_SOURCE_ID = 'public-land-source';
export const PUBLIC_LAND_SOURCE_LAYER = 'public_land';
export const PUBLIC_LAND_FILL_LAYER = 'public-land-fill';
export const PUBLIC_LAND_LINE_LAYER = 'public-land-line';

/** Extracted as a const so tests can spy on console.warn for this message. */
export const WARN_MISSING_SOURCE_LAYER =
  'PublicLandLayer: expected source-layer "public_land" — verify PMTiles schema';
